import { IColumnDefinition } from "../types/commons";

const moneyColDef: IColumnDefinition = {
	field: "",
	header: "",
	alignHeader: "left",
	alignCell: "right",
	type: "money",
};

const numberColDef: IColumnDefinition = {
	field: "",
	header: "",
	alignHeader: "left",
	alignCell: "left",
	type: "decimals_2",
};

const hoursColDef: IColumnDefinition = {
	field: "",
	header: "",
	alignHeader: "left",
	alignCell: "left",
	type: "hours",
};

function objToRecord<TVal = unknown>(obj: object): Record<string, TVal> {
	return Object.entries(obj).reduce((acc: Record<string, TVal>, [key, value]) => {
		acc[key] = value;
		return acc;
	}, {});
}

export { hoursColDef, moneyColDef, numberColDef, objToRecord };
